import { getTheme, ITextFieldStyles, TextField } from '@fluentui/react';
import { FunctionComponent, useEffect, useState } from 'react';
export interface IBwjLabelFieldProps {
  id?: string;
  label: string;
  value: string;
  noBorder?: boolean;
  multiline?: boolean;
  highlightColor?: string;
}

export const BwjLabelField: FunctionComponent<IBwjLabelFieldProps> = (props) => {
  const {noBorder, highlightColor } = props;
  const [componentStyles, setComponentStyles] = useState<Partial<ITextFieldStyles>>({});
  const theme = getTheme();
  
  useEffect(() => {
    setComponentStyles({
      fieldGroup:[
        !!noBorder && { 
          borderColor: 'transparent',
          borderRadius: 0,
          borderBottomColor: theme.palette.neutralLight,
         },
        !!highlightColor && { backgroundColor: highlightColor },
      ],
    });
  }, [noBorder, highlightColor, theme]);

  return (
    <TextField id={props.id} label={props.label} readOnly value={props.value} styles={componentStyles} />
  );
};